import type { FC } from 'react'

import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const data = {
  heading: `Interested in hearing more about how Segment can help you?`,
  button: {
    text: `Request a demo`,
  },
}

const RequestDemo: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionBase variant="noCopy">
      <StyledSectionContents>
        <CopyTextBase centered={true}>
          <StyledCopyTextHeading tag="h3" variant="h2">
            {data.heading}
          </StyledCopyTextHeading>
          <Button size="large" color="primary" variant="filled" tag="a" href={getAbsoluteUrl(`/demo/`, pageConfig)}>
            {data.button.text}
          </Button>
        </CopyTextBase>
      </StyledSectionContents>
    </SectionBase>
  )
}

const StyledCopyTextHeading = styled(CopyText.Heading)`
  margin-bottom: 32px;
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 684px;
  margin: 0 auto;
`

export default RequestDemo
